// Manual ad loading test - run this in the console
window.testAdLoading = function() {
    console.log('=== Manual Ad Loading Test ===');
    
    if (!window.store) {
        console.error('Store not available');
        return;
    }
    
    const adsState = window.store.state.ads;
    console.log('Available ads in store:', adsState.ads);
    
    if (!window.Vue || !window.Vue.prototype.$adService) {
        console.error('AdService not available');
        return;
    }
    
    const adService = window.Vue.prototype.$adService;
    console.log('AdService slots:', Object.keys(adService.slots));
    
    // Try to force load each slot
    Object.keys(adService.slots).forEach(slotId => {
        const slot = adService.slots[slotId];
        console.log(`\nTesting slot ${slotId}:`);
        console.log('- Location:', slot.location);
        console.log('- Loaded:', slot.loaded);
        console.log('- In DOM:', document.body.contains(slot.element));
        
        // Check what ads are available for this location
        const locationAds = adsState.ads.filter(ad => ad.location === slot.location);
        console.log(`- Ads for location ${slot.location}:`, locationAds);
        
        // Try to find ad data
        const adData = slot.findAdData();
        console.log('- Found ad data:', adData);
        
        if (!slot.loaded && adData) {
            console.log(`- Attempting to load slot ${slotId}...`);
            slot.load(adData);
        }
    });
    
    console.log('=== End Manual Test ===');
};

// Function to manually trigger store watcher
window.triggerAdCheck = function() {
    if (window.Vue && window.Vue.prototype.$adService) {
        const adService = window.Vue.prototype.$adService;
        console.log('Manually triggering ad slot check...');
        adService.checkSlotsForNewAds();
    }
};
